import React from "react";
import { useTranslation } from "react-i18next";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";
import { MultiScopeTranslationPayload } from "store/gameCenter/multiScope/slice";
import "./MultiScopeLocalesTab.scss";

type Props = {
  locales: string[];
  activeLocale: string;
  translation?: MultiScopeTranslationPayload;
  loading: boolean;
  fieldErrors: Record<string, string>;
  onLocaleChange: (locale: string) => void;
  onChange: (values: Partial<MultiScopeTranslationPayload>) => void;
};

const MultiScopeLocalesTab: React.FC<Props> = ({ locales, activeLocale, translation, loading, fieldErrors, onLocaleChange, onChange }) => {
  const { t } = useTranslation();

  return <>
    <div className="game-modal-tabs small multi-scope-locales-tabs">
      {locales.map((locale) => <div key={locale} className={`tab-item ${activeLocale === locale ? "active" : ""}`} onClick={() => onLocaleChange(locale)}>
        <img src={`https://flagpedia.net/data/flags/icon/16x12/${locale.split("-")[1]?.toLowerCase()}.png`} alt="" />
        {locale}
      </div>)}
    </div>
    {loading ? <ModalTabSkeleton /> : <div className="game-form-wrapper multi-scope-locales-wrapper">
      <div className="game-form-content multi-scope-locales-form">
        <div className="game-form-box--item multi-scope-locales-form__title"><InnerInput id="multi-scope-translation-title" label={t("title")} type="text" value={translation?.title ?? ""} onChange={(title) => onChange({ title })} hasError={Boolean(fieldErrors.title)} disabled={!activeLocale} /></div>
        <div className="game-form-box--item multi-scope-locales-form__active"><SwitchBtn activeTxt={t("active")} isActive={Boolean(translation?.isActive)} handleClick={() => onChange({ isActive: !translation?.isActive })} disabled={!activeLocale} hasError={Boolean(fieldErrors.isActive)} /></div>
      </div>
    </div>}
  </>;
};

export default MultiScopeLocalesTab;
